import { Injectable } from '@angular/core';

import { FixtureFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel, EventOptionGroupType } from '@frontend/sports/betting-offer/feature/model';
import { ConnectionConfig } from '@frontend/sports/common/client-config-data-access';
import {
    CdsPushService,
    CdsSubscription,
    FixtureAllSubscription,
    GridSubscription,
    ScoreboardSlimSubscription,
} from '@frontend/sports/content-distribution/feature';
import { MessageCallback } from '@frontend/sports/event-subscription/feature/base-subscription';
import { EventSubscriptionService } from '@frontend/sports/event-subscription/feature/event-subscription';

/**
 * This service should be used for subscribing marquee for push. It automatically subscribes to available markets of
 * the event in the response. When there is no available market it subscribes to all markets.
 *
 * @export
 * @class MarqueeEventSubscriptionService
 * @extends {BaseSubscriptionService}
 */
@Injectable({ providedIn: 'root' })
export class MarqueeEventSubscriptionService extends EventSubscriptionService {
    constructor(
        fixtureFactory: FixtureFactory,
        push: CdsPushService,
        protected override connection: ConnectionConfig,
    ) {
        super(fixtureFactory, push, connection);
    }

    protected override getContextSubscriptions(event: EventModel, callback: MessageCallback): CdsSubscription[] {
        const isDynamicOptionGroup = event.optionGroups?.find((x) => x.type === EventOptionGroupType.DynamicMarket);
        const isSixPack = event.optionGroups?.find((x) => x.type === EventOptionGroupType.SixPack);
        if (isSixPack) {
            return [new GridSubscription(event.offerContext, event.id, this.connection.culture, callback)];
        } else if (event.optionGroups && event.optionGroups.length && !isDynamicOptionGroup) {
            return super.getContextSubscriptions(event, callback);
        }

        return [
            new FixtureAllSubscription(event.offerContext, event.id, this.connection.culture, callback),
            new ScoreboardSlimSubscription(event.offerContext, event.id, this.connection.culture, callback),
        ];
    }
}
